import ViewPatients from './ViewPatients';

export default ViewPatients;
